import api from './api';

class TransactionService {
  async getTransactions(filters = {}) {
    const params = new URLSearchParams(filters).toString();
    const response = await api.get(`/v1/transactions?${params}`);
    return response.data;
  }

  async getTransaction(id) {
    const response = await api.get(`/v1/transactions/${id}`);
    return response.data;
  }

  async createTransaction(data) {
    const response = await api.post('/v1/transactions', data);
    return response.data;
  }

  async batchCreateTransactions(data) {
    const response = await api.post('/v1/transactions/batch', data);
    return response.data;
  }

  async updateTransaction(id, data) {
    const response = await api.put(`/v1/transactions/${id}`, data);
    return response.data;
  }

  async deleteTransaction(id) {
    const response = await api.delete(`/v1/transactions/${id}`);
    return response.data;
  }

  async togglePaid(id) {
    const response = await api.patch(`/v1/transactions/${id}/toggle-paid`);
    return response.data;
  }

  async getSummary(filters = {}) {
    const params = new URLSearchParams(filters).toString();
    const response = await api.get(`/v1/transactions/summary?${params}`);
    return response.data;
  }

  async getMonthlyDashboard(year, month) {
    const params = new URLSearchParams({ year, month }).toString();
    const response = await api.get(`/v1/transactions/monthly-dashboard?${params}`);
    return response.data;
  }

  async getTopCategories(year, month, limit = 5) {
    const params = new URLSearchParams({ year, month, limit }).toString();
    const response = await api.get(`/v1/transactions/top-categories?${params}`);
    return response.data;
  }

  // Reports endpoints
  async getCategoryEvolutionReport(categoryId, startDate, endDate) {
    const params = new URLSearchParams({
      category_id: categoryId,
      start_date: startDate,
      end_date: endDate
    }).toString();
    const response = await api.get(`/v1/transactions/reports/category-evolution?${params}`);
    return response.data;
  }

  async getCategoryMonthTransactions(categoryId, month) {
    const params = new URLSearchParams({
      category_id: categoryId,
      month: month
    }).toString();
    const response = await api.get(`/v1/transactions/reports/category-month-transactions?${params}`);
    return response.data;
  }

  async getMonthlyAggregatedReport(startDate, endDate, categoryIds = []) {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate
    });
    
    // Add category_ids as array params
    if (categoryIds.length > 0) {
      categoryIds.forEach(id => params.append('category_ids[]', id));
    }
    
    const response = await api.get(`/v1/transactions/reports/monthly-aggregated?${params.toString()}`);
    return response.data;
  }

  async getCategoryDistributionReport(type, startDate, endDate, categoryIds = []) {
    const params = new URLSearchParams({
      type: type,
      start_date: startDate,
      end_date: endDate
    });
    
    // Add category_ids as array params
    if (categoryIds.length > 0) {
      categoryIds.forEach(id => params.append('category_ids[]', id));
    }
    
    const response = await api.get(`/v1/transactions/reports/category-distribution?${params.toString()}`);
    return response.data;
  }

  // PDF Report
  async generatePdfReport(filters = {}, preview = false) {
    const params = new URLSearchParams({
      start_date: filters.startDate,
      end_date: filters.endDate,
      status: filters.status || 'all',
      include_virtual: filters.includeVirtual !== undefined ? (filters.includeVirtual ? '1' : '0') : '1'
    });
    
    // Add category_ids as array params
    if (filters.categoryIds && filters.categoryIds.length > 0) {
      filters.categoryIds.forEach(id => params.append('category_ids[]', id));
    }
    
    const response = await api.get(`/v1/reports/pdf/transactions?${params.toString()}`, {
      responseType: 'blob' // Important for binary data
    });
    
    // Create a blob from the PDF Stream
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    if (preview) {
      // Return URL for preview
      return { success: true, url };
    } else {
      // Download immediately
      const link = document.createElement('a');
      link.href = url;
      link.download = `relatorio-transacoes-${new Date().toISOString().split('T')[0]}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      return { success: true };
    }
  }
}

export default new TransactionService();
